import { Linkedin } from 'lucide-react';
import { XIcon } from './XIcon';

interface SocialShareProps {
  slug: string;
  title: string;
  url?: string;
  size?: 'sm' | 'md';
  className?: string;
}

export function SocialShare({ slug, title, url, size = 'md', className = '' }: SocialShareProps) {
  const shareUrl = url || `https://thecisonetwork.com/news/${slug}`;
  const linkedInHref = `https://www.linkedin.com/feed/?shareActive=true&text=${encodeURIComponent(title + '\n\n' + shareUrl)}`;
  const xHref = `https://twitter.com/intent/tweet?text=${encodeURIComponent(title + '\n\n')}${encodeURIComponent(shareUrl)}`;

  const btnClasses = size === 'sm' ? 'w-8 h-8' : 'w-10 h-10';
  const iconClasses = size === 'sm' ? 'h-3.5 w-3.5' : 'h-4 w-4';

  const openShare = (href: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    window.open(href, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <button
        type="button"
        onClick={openShare(linkedInHref)}
        aria-label="Share on LinkedIn"
        title="Share to LinkedIn"
        className={`group/share inline-flex items-center justify-center ${btnClasses} text-foreground/70 bg-background border border-border rounded-full hover:bg-teal hover:text-white hover:border-teal transition-colors [perspective:1000px]`}
      >
        <Linkedin className={`${iconClasses} group-hover/share:[animation:flip-y_0.5s_ease-out]`} />
      </button>
      <button
        type="button"
        onClick={openShare(xHref)}
        aria-label="Share on X"
        title="Share to X"
        className={`group/share inline-flex items-center justify-center ${btnClasses} text-foreground/70 bg-background border border-border rounded-full hover:bg-teal hover:text-white hover:border-teal transition-colors [perspective:1000px]`}
      >
        <XIcon className={`${iconClasses} group-hover/share:[animation:flip-y_0.5s_ease-out]`} />
      </button>
    </div>
  );
}
